/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TenantEmailSettingsEditDto
 */
export interface TenantEmailSettingsEditDto {
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsEditDto
     */
    defaultFromAddress: string;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsEditDto
     */
    defaultFromDisplayName: string;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsEditDto
     */
    smtpHost: string;
    /**
     * 
     * @type {number}
     * @memberof TenantEmailSettingsEditDto
     */
    smtpPort: number;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsEditDto
     */
    smtpUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsEditDto
     */
    smtpPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsEditDto
     */
    smtpDomain?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantEmailSettingsEditDto
     */
    smtpEnableSsl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantEmailSettingsEditDto
     */
    useHostDefaultEmailSettings?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsEditDto
     */
    $type?: TenantEmailSettingsEditDtoTypeEnum;
}


/**
 * @export
 */
export const TenantEmailSettingsEditDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedConfigurationTenantsDtoTenantEmailSettingsEditDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Configuration.Tenants.Dto.TenantEmailSettingsEditDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TenantEmailSettingsEditDtoTypeEnum = typeof TenantEmailSettingsEditDtoTypeEnum[keyof typeof TenantEmailSettingsEditDtoTypeEnum];


/**
 * Check if a given object implements the TenantEmailSettingsEditDto interface.
 */
export function instanceOfTenantEmailSettingsEditDto(value?: unknown): value is TenantEmailSettingsEditDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TenantEmailSettingsEditDtoTypeEnum)[0];
}

export function TenantEmailSettingsEditDtoFromJSON(json: any): TenantEmailSettingsEditDto {
    return TenantEmailSettingsEditDtoFromJSONTyped(json, false);
}

export function TenantEmailSettingsEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantEmailSettingsEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'defaultFromAddress': json['defaultFromAddress'],
        'defaultFromDisplayName': json['defaultFromDisplayName'],
        'smtpHost': json['smtpHost'],
        'smtpPort': json['smtpPort'],
        'smtpUserName': !exists(json, 'smtpUserName') ? undefined : json['smtpUserName'],
        'smtpPassword': !exists(json, 'smtpPassword') ? undefined : json['smtpPassword'],
        'smtpDomain': !exists(json, 'smtpDomain') ? undefined : json['smtpDomain'],
        'smtpEnableSsl': !exists(json, 'smtpEnableSsl') ? undefined : json['smtpEnableSsl'],
        'useHostDefaultEmailSettings': !exists(json, 'useHostDefaultEmailSettings') ? undefined : json['useHostDefaultEmailSettings'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TenantEmailSettingsEditDtoToJSON(value?: TenantEmailSettingsEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'defaultFromAddress': value.defaultFromAddress,
        'defaultFromDisplayName': value.defaultFromDisplayName,
        'smtpHost': value.smtpHost,
        'smtpPort': value.smtpPort,
        'smtpUserName': value.smtpUserName,
        'smtpPassword': value.smtpPassword,
        'smtpDomain': value.smtpDomain,
        'smtpEnableSsl': value.smtpEnableSsl,
        'useHostDefaultEmailSettings': value.useHostDefaultEmailSettings,
        '$type': value.$type,
    });
}

